import { jsx as a } from "react/jsx-runtime";
import { forwardRef as f, useState as p, useImperativeHandle as d } from "react";
import { Snackbar as m, Alert as h } from "@mui/material";
const w = f(({ message: n, duration: i, type: r }, s) => {
  const [l, e] = p(!1);
  d(s, () => ({
    openToast: () => e(!0),
    closeToast: () => e(!1)
  }));
  const t = (u, c) => {
    c !== "clickaway" && e(!1);
  };
  let o = i;
  return o == null && r != "error" && (o = 1e3 * 5), /* @__PURE__ */ a(
    m,
    {
      open: l,
      autoHideDuration: o,
      onClose: t,
      anchorOrigin: { vertical: "top", horizontal: "center" },
      sx: { marginTop: "env(safe-area-inset-top)" },
      children: /* @__PURE__ */ a(h, { onClose: t, severity: r, sx: { width: "100%" }, children: n })
    }
  );
});
export {
  w as Toast
};
//# sourceMappingURL=index.js.map
